import { type RGProduct, rootFormatter } from "@raumagarn/formatters";
import { defineFormatter } from "@trydig/centra/formatting";
import { getProductTags, getYarnType, getYarnWeightAndLength } from "./utils";

export const formatProductCard = defineFormatter((product: RGProduct) => {
	const rootProduct = rootFormatter(product);
	const cannonicalCategory = product.categoryName?.[0];
	const fits = product.pr_fits?.join(", ");
	const categories = product?.categoryName;
	const id = product.product;

	const media = rootProduct.media;

	const image = media?.[0];
	const secondImage = media?.[1];
	const tags = getProductTags(product);
	const sku = product.sku;

	const yarnMaterials = product.pr_composition_text_compositionText;
	const yarnType = getYarnType(product);
	const yarnLengthAndWeight = getYarnWeightAndLength(product);

	const outlet = product.pr_is_outlet_loc || [];

	if (cannonicalCategory === "Outlet") {
		// Explnation: All products in outlet category should always be marked as outlet in all markets
		outlet?.push("NOK");
		outlet?.push("DKK");
		outlet?.push("SEK");
	}

	const freeRecipe = product.pr_free_recipe_loc || [];
	const archive = product.pr_is_archive_loc || [];

	const newVariantColor = product.var_new_color_extended === "1";

	return {
		...(rootProduct as Omit<typeof rootProduct, "variants" | "relatedProducts">),
		id,
		categories,
		sku,
		yarnMaterials,
		fits,
		cannonicalCategory,
		relation: product.relation,
		media: media as typeof media | undefined,
		gallery: {
			image,
			secondImage,
		},
		relatedProducts: rootProduct.relatedProducts,
		yarnOptionLength: rootProduct.variants.length > 0 ? rootProduct.variants.length : undefined,
		weight: product.pr_display_weight_value,
		length: product.pr_length_length,
		yarnType,
		yarnLengthAndWeight,
		tags,
		comingSoon: product.pr_comingsoon_loc,
		outlet,
		isOutlet: outlet.length > 0,
		freeRecipe,
		isFreeRecipe: freeRecipe.length > 0,
		archive,
		isArchive: archive,
		showAsNew: product.showAsNew,
		showAsOnSale: product.showAsOnSale,
		newVariantColor,
		isNew: product.showAsNew || newVariantColor,
	};
});
export type ProductCard = ReturnType<typeof formatProductCard>;
